/**
 * 订单管理 交易订单
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input
          size="small"
          v-model="phone"
          placeholder="请输入会员手机号"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-upload2"
          @click="exportList"
          >导出列表</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="menberList"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column
        prop="avatarUrl"
        label="头像"
        width="150"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          <img
            :src="scope.row.avatarUrl"
            alt="头像"
            style="max-width: 100%; max-height: 80px"
          />
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="用户名" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="phone" label="手机号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="balance" label="余额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="vipPoints" label="积分" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="vipPoints" label="标签" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.tags" :key="index">
            <div style="color: #409eff" v-if="item.type == 'primary'">
              <i class="el-icon-s-flag">{{ item.name }}</i>
            </div>
            <div style="color: #e6a23c" v-else-if="item.type == 'warning'">
              <i class="el-icon-s-flag">{{ item.name }}</i>
            </div>
            <div style="color: #67c23a" v-else-if="item.type == 'success'">
              <i class="el-icon-s-flag">{{ item.name }}</i>
            </div>
            <div style="color: #f56c6c" v-else-if="item.type == 'error'">
              <i class="el-icon-s-flag">{{ item.name }}</i>
            </div>
            <div style="color: #b76cf5" v-else-if="item.type == 'royal'">
              <i class="el-icon-s-flag">{{ item.name }}</i>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="注册时间" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="80">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <!-- <el-button
            size="mini"
            type="danger"
            @click="deleteUser(scope.$index, scope.row)"
            >退款</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="50%"
      @closed="closeDialog('editForm')"
    >
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-col :span="20">
            <el-form-item label="用户名">
              <el-input
                size="small"
                v-model="editForm.nickName"
                auto-complete="off"
                placeholder="用户名"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input
                size="small"
                v-model="editForm.phone"
                auto-complete="off"
                placeholder="手机号"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户余额">
              <el-input
                size="small"
                v-model="editForm.balance"
                auto-complete="off"
                placeholder="用户余额"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户积分">
              <el-input
                size="small"
                v-model="editForm.vipPoints"
                auto-complete="off"
                placeholder="用户积分"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户标签">
              <div>
                <!-- <el-select v-model="editForm.tags" placeholder="请选择">
                <el-option
                  v-for="item in colorRange"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->

                <el-cascader
                  :options="options"
                  :props="props"
                  collapse-tags
                  clearable
                  @change="changeTags"
                ></el-cascader>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { OrderList, OrderRefund, OrderDelete  } from "../../api/payMG";
import Pagination from "../../components/Pagination";

import { blobValidate } from "@/utils/ruoyi";
import { saveAs } from "file-saver";

import {
  getGoodsList,
  getGoodsTypeList,
  getMemberList,
  editMemberInfo,
  getLabelList,
} from "@/api/api.js";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "会员用户设置",
      date: "",
      year: "",
      month: "",
      day: "",
      menberList: [],
      goodsStatus: "", //商品类型
      // 会员标签
      props: { multiple: true },
      options: [
        {
          value: 1,
          label: "东南",
        },
        {
          value: 17,
          label: "西北",
        },
      ],
      colorRange: [
        {
          text: "蓝色",
          value: "primary",
        },
        {
          text: "绿色",
          value: "success",
        },
        {
          text: "紫色",
          value: "royal",
        },
        {
          text: "黄色",
          value: "warning",
        },
        {
          text: "红色",
          value: "error",
        },
      ],
      payway: [
        { key: "全部订单", value: 0 },
        { key: "已完成订单", value: 1 },
        { key: "已取消订单", value: 2 },
        { key: "已退款订单", value: 3 },
      ],
      goodsTypeList: [], //商品类型列表
      orderList: "", //订单列表
      phone: "", //会员手机号
      goodsList: [], //商品列表
      editForm: {
        tags: [],
      },
      formInline: {
        page: 1,
        limit: 10,
        machineNo: "",
        orderNo: "",
        transId: "",
        payType: 0,
        orderStatus: 0,
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline);
    // this.getGoodsType();//获取商品类型列表
    this.getData(); //获取商品列表
    this.getLabelList(); //获取标签列表
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    //获取商品类型列表
    getGoodsType() {
      getGoodsTypeList().then((res) => {
        //改变数组里元素的某个属性
        res.data.forEach((item) => {
          item.key = item.name;
          item.value = item.id;
        });
        //在数组开头添加一个元素
        res.data.unshift({ key: "所有", value: "" });
        this.goodsTypeList = res.data;
      });
    },
    //获取会员列表
    getData() {
      this.loading = true;
      getMemberList({
        phone: this.phone,
        pageNum: this.pageparm.currentPage,
        storeId: localStorage.getItem("storeId"),
      }).then((res) => {
        this.menberList = res.data.records;
        this.loading = false;
        this.pageparm.currentPage = this.formInline.page;
        this.pageparm.pageSize = this.formInline.limit;
        this.pageparm.total = res.data.total;
      });
    },
    //获取标签列表
    getLabelList() {
      getLabelList().then((res) => {
        console.log(res, "标签列表");
        if (res.code == 0) {
          //给数组里面的每一个元素添加一个属性
          res.data.forEach((item) => {
            item.label = item.name;
            //把item对象变成字符串
            item.value = JSON.stringify(item);
          });
          this.options = res.data;
        } else {
          this.$message({
            type: "error",
            message: "获取标签失败",
          });
        }
      });
    },
    //改变标签
    changeTags(val) {
      console.log(val, "标签");
      //把val里面的每一个元素变成对象
      val.forEach((item, index) => {
        val[index] = JSON.parse(item);
      });
      this.editForm.tags = val;
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = 10;
      // this.getdata(this.formInline)
      this.getData();
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
      this.getData();
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = row;
      console.log(index, row, "333333");
    },
    // 编辑、增加页面保存方法
    submitForm() {
      console.log(11111, this.editForm);
      editMemberInfo(this.editForm).then((res) => {
        if (res.code == 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.editFormVisible = false;
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });

      // editMemberInfo(this.editForm).then((res)=>{

      // })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.getData();
      this.$refs[formName].resetFields();
    },

    //导出列表
    exportList() {
      this.$confirm("确定导出会员列表吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .get(
              `https://ht.wteam.club/api/wxuser/ExportStoreVipList?storeId=${localStorage.getItem("storeId")}`,
              {
                headers: {
                  "Content-Type": "application/vnd.ms-excel;charset=UTF-8",
                  "token":localStorage.getItem('token'),
                },
                responseType: "blob",
              }
            )
            .then(async (res) => {
              const isLogin = await blobValidate(res);
              if (res.status == 200) {
                if (isLogin) {
                  // console.log(new Blob([res]));
                  const blob = new Blob([res.data]);
                  console.log("blob1111", blob);
                  saveAs(blob, `会员列表_${new Date().getTime()}.xlsx`);
                  this.$message({
                    type: "success",
                    message: "导出成功",
                  });
                } else {
                  const resText = await res.text();
                  const rspObj = JSON.parse(resText);
                  const errMsg =
                    errorCode[rspObj.code] ||
                    rspObj.msg ||
                    errorCode["default"];
                  this.$message.error(errMsg);
                }
                this.$modal.closeLoading();
              } else {
                this.$message.error("导出失败");
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消导出",
          });
        });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/system/user.vue